var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"robo-soul-page"},[_c('overview-section'),_c('schema-section'),_c('algorithmic-section'),_c('cmi-mpi-section'),_c('development-process-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }